export default __webpack_public_path__ + "static/media/A0007.945b2a5f.png";